<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ translation.Payment.PaymentTypes.STCPay | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-label>
    <h2 class="ion-padding">{{ translation.Payment.PleaseEnterSTCPayMobile | translate }}</h2>
  </ion-label>

  <ion-list class="full-width-lines">
    <ion-item>
      <ion-label position="stacked">{{ translation.Payment.MobileNumber | translate }}</ion-label>
      <ion-input [(ngModel)]="mobile" type="number" placeholder="966.." [disabled]="authorizeResponse !== null"></ion-input>
    </ion-item>

    <ion-item>
      <ion-checkbox [(ngModel)]="useRegisteredMobile" (ionChange)="useRegisteredMobileNumber()" labelPlacement="end" justify="start">
        {{ translation.Payment.UseRegisterdMobileNumber | translate }}
      </ion-checkbox>
    </ion-item>

    <ng-container *ngIf="authorizeResponse">
      <hr />

      <ion-item>
        <ion-label position="stacked">{{ translation.Payment.VerificationCode | translate }}</ion-label>
        <ion-input [(ngModel)]="code" type="number" placeholder=""></ion-input>
      </ion-item>
    </ng-container>
  </ion-list>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-row>
    <ion-col>
      <ion-button expand="block" (click)="next()">{{ translation.Common.Next | translate }}</ion-button>
    </ion-col>
    <ion-col>
      <ion-button color="light" expand="block" (click)="cancel()">{{ translation.Common.Cancel | translate }}</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
